import { request } from '@/api/common'
import apis from '@/common/config/host'

const GET_MARKETING_INFO = apis.cApiDomain + '/shop/marketingInfo' // 等接口

export const getMarketingInfo = function (data) {
  return request.post(GET_MARKETING_INFO, {data: {...data}})
}
